define('app/sdc/perspective/sdc-perspective',["$window"], function ($window) {
	var browserPrefixes = [null, "-moz-", "-ms-", "-webkit-"];
	return {
		restrict: "A",
		scope: false,
		controller: {
			constructor: ["$element", "$watch", "$attrs", "$self", "$scope", function ($element, $watch, $attrs, vm, $scope) {
				var currentWidth, perspectiveDistance;
				function updatePerspective(width) {
					if (!arguments.length) {
						width = $element.width();
					}
					if (width !== currentWidth) {
						perspectiveDistance = width + "px";
						var styles = {};
						angular.forEach(browserPrefixes, function (prefix) {
							if (!prefix) {
								prefix = "";
							}
							styles[prefix + "perspective"] = perspectiveDistance;
						});
						$element.css(styles);
					}
				}
				function windowResizeHandler() {
					updatePerspective();
				}
				angular.element($window).on("resize", windowResizeHandler);
				$watch.controller($element.width.bind($element), function $element_on$widthChanged(width) {
					updatePerspective(width);
				});
				$scope.$on("$destroy", function $scope_on$destroy() {
					$window.off("resize", windowResizeHandler);
				});
				updatePerspective();
			}]
		}
	}
});
